export default __webpack_public_path__ + "static/media/grenada_icon.1b31e392.svg";